import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import config from 'custom/config/environment'

const fallbackLng = ['en']
// const availableLanguages = ['en', 'fr', 'kh', 'zh']


i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend:{
      loadPath: `${process.env.REACT_APP_CONTEXT}locales/{{lng}}/{{ns}}.json`
    },
    fallbackLng,
    debug: false,
    whitelist: config.LANGUAGE_LIST,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
